const QUERY_STRING_PREFIX = '?';
const ABSOLUTE_URL_REGEX = /^[a-z][a-z0-9+.-]*:/;

export {
  QUERY_STRING_PREFIX,
  ABSOLUTE_URL_REGEX,
};
